export const ModuleName = 'enkat';
export const DisplayName = 'Enkäter';
